<template>
  <div>
    <div class="m-0 p-0">
      <template v-if="!fromChecklist">
        <b-form-tag
          v-for="(tag, index) in tagList"
          :key="index"
          :title="tag"
          variant="primary"
          class="tag-class mb-2"
          @remove="removeTag(tag)">
          {{ tag }}
        </b-form-tag>
      </template>
      <b-input-group class="tag-input-row">
        <vue-autosuggest
          :ref="'vueAutoSuggest'"
          v-model="searchQuery"
          class="tag-input"
          :suggestions="filteredOptions"
          :input-props="{id: 'coozzy-tag-input', placeholder: fromChecklist ? $t('message.settings.template.checklist.addTask') : $t('message.contact.addTag')}"
          @selected="onSuggestionSelected"
          @keyup.enter="addCustomTag">
          <template #default="{ suggestion }">
            <strong>
              {{ suggestion.item }}
            </strong>
          </template>
        </vue-autosuggest>
        <b-input-group-append
          class="tag-btn">
          <coozzy-button
            size="normal"
            class="light-grey"
            @click="addCustomTag()">
            {{ $t('message.generic.add') }}
          </coozzy-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'

export default {
  name: 'CoozzyFormTag',
  components: {
    CoozzyButton,
    VueAutosuggest
  },
  props: {
    initial: {
      type: Array,
      default: () => {
        return []
      }
    },
    suggestions: {
      type: Array,
      default: () => {
        return []
      }
    },
    fromChecklist: {
      type: Boolean,
      default: false
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tagList: this.initial,
      searchQuery: ''
    }
  },
  computed: {
    filteredOptions() {
      return [
        {
          data: this.suggestions.filter(option => {
            return option?.toLowerCase().indexOf(this.searchQuery?.toLowerCase()) > -1
          })
        }
      ]
    }
  },
  watch: {
    tagList: {
      handler(oldVal, newVal) {
        if (newVal.length < oldVal.length) {
          this.searchQuery = ''
        }
      }
    },
    initial: {
      handler(oldVal, newVal) {
        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
          this.tagList = this.initial
        }
      }
    }
  },
  methods: {
    addCustomTag() {
      const trimmedQuery = this.searchQuery?.trim()
      if (trimmedQuery) {
        if (!this.allowDuplicates && this.tagList.includes(trimmedQuery)) {
          return
        }

        this.tagList.push(trimmedQuery)
        this.searchQuery = ''
        this.$emit('input', this.tagList)
      }
    },
    onSuggestionSelected(suggestion) {
      if (suggestion) {
        const { setChangeItem } = this.$refs.vueAutoSuggest
        setChangeItem(-1, true)
        this.tagList.push(suggestion.item)
        this.searchQuery = ''
        this.$emit('input', this.tagList)
        this.$emit('suggestion-selected', suggestion.item)
      }
    },
    removeTag(tag) {
      const index = this.tagList.indexOf(tag)
      if (index > -1) {
        this.tagList.splice(index, 1)
        this.$emit('input', this.tagList)
        this.$emit('suggestion-removed', tag)
      }
    },
    tagsRemoved(tag) {
      this.$emit('suggestion-removed', tag)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep() {
  .light-grey {
    background: #f0f3f5 !important;
  }
  .b-form-tags{
    border: none;
  }
    .tag-input {
    flex: 1;

    // Use unique ID to avoid base.scss conflicts
    #coozzy-tag-input {
      width: 100% !important;
      padding: 0.2em 8px !important;
      height: 38px !important;
      font-size: 0.875rem !important;
      line-height: 1.5 !important;
      border-radius: 0.2rem !important;
      color: #495057 !important;
      background-color: #fff !important;
      background-clip: padding-box !important;
      border: 1px solid #ced4da !important;
    }

    #coozzy-tag-input:focus,
    #coozzy-tag-input:focus-visible {
      border-color: #80bdff !important;
      outline: 0 !important;
      -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%) !important;
      box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%) !important;
    }

    ul {
      list-style: none;
      display: inline-block;
      padding: 0;
      margin: 0;
      min-width: 100%;
      vertical-align: top;
      li {
        font-size: 16px;
        padding-left: 10px;
      }
      li:hover {
        background-color: $color-primary;
        color: white;
      }
    }
  }

  .tag-input-row{
    display: flex;
  }
  .tag-class {
    font-size: 1rem;
    background-color: $color-primary;
    button {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }
  }
  .tag-btn{
    height: 38px;
  }
}
</style>
